import type { RentalType, SearchInputType } from '../types';
import { ErrorsContextProps } from '../types';

export const validateInputs = (
  data: [string, any][],
  differentAgencies: boolean,
  errorsContext: ErrorsContextProps['updateErrorsState'],
) => {
  const hasEmptyFields = !data.every(([key, state]) =>
    Object.entries(state).every(([type, entry]) => {
      if (!entry) {
        if (key === 'location') {
          const locationType = (differentAgencies ? type : 'oneway') as SearchInputType;
          errorsContext.locationError[locationType](true);
        }

        if (key === 'dates') {
          errorsContext.datesError[type as RentalType](true);
        }

        if (key === 'time') {
          errorsContext.timeError[type as RentalType](true);
        }

        return false; // break iteration.
      }

      return true; // continue iteration.
    }),
  );

  return hasEmptyFields;
};
